// extracted by mini-css-extract-plugin
export var skipAnimation = "_34-0";